import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-04/task-02";

const task: Slide = {
  title: "Rank the Helmholtz resonators below in order of increasing resonance frequency.",
  description: "Drag and drop elements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
